import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual } from 'helpers/utils'
import { isLess4Intermediates, isPhaseFinal } from 'components/sports/swm/helper/SwmHelpers'
import { getRscObject } from "helpers/rsc"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Esl from "components/common/Esl";

export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { config } = props;
    const data = ((row?.extendedResults?.length > 0))
        ? row?.extendedResults
        : undefined
    const eslData = row?.extCompetitor

    const { mirs_rsc } = useUrlFriendlyToParameters()
    const isLess4 = isLess4Intermediates(mirs_rsc);
    const isFinal = isPhaseFinal(mirs_rsc);
    return (
        <>
            <Esl data={eslData} />
            <table className="table table-detail">
                <thead>
                    <tr>
                        <th className="text-end w-5">
                            {!isLess4 && isFinal
                                ? <Label data="HeaderQualifyingTime" />
                                : <Label data="HeaderEntryTime" />
                            }
                        </th>
                        <th className="text-end w-5"><Label data="HeaderReaction" /></th>
                        <th className="text-start w-10"><Label data="HeaderDistance" /></th>
                        <th className="text-end w-10"><Label data="HeaderTime" /></th>
                        <th className="text-end w-10"><Label data="HeaderRank" /></th>
                        <th className="text-end w-10"><Label data="HeaderSplitTime" /></th>

                    </tr>
                </thead>
                <tbody>
                    {config && config.filter(rowConf => rowConf.pos !== 'S' && rowConf.code === 'INTERMEDIATE').map((val, key) => {

                        let res = findArray(data, { er_pos: [val.pos] })
                        let react = findArray(data, { er_code: ['REACT_TIME'] })
                        let reactionTime = (res.er_pos === '1')
                            ? <> {react.er_value} </>
                            : ''
                        let qualTime = row?.eventUnitEntries?.find(item => item.eue_code === 'QUAL_TIME')?.eue_value;
                        let entryTime = (res.er_pos === '1')
                            ? <> {qualTime} </>
                            : ''
                        let headerValue = (res.er_pos === 'F')
                            ? <Label data="HeaderFinish" />
                            : <> {val.value}<Label data="LabelM" /> </>

                        return (
                            <tr key={'expanded_' + row.participant.code + '_' + key}>
                                <td style={{ textAlign: "right" }}>{entryTime}</td>
                                <td style={{ textAlign: "right" }}>{reactionTime}</td>
                                <td><strong>{headerValue}</strong></td>
                                <td style={{ textAlign: "right" }}>{res.er_value}</td>
                                <td style={{ textAlign: "right" }}>{res.er_rank}</td>
                                <td style={{ textAlign: "right" }}>{res.er_diff}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row, nextProps.row)
    )
});